import { FilterSearchResultItem } from '@/components/filters/filter-search-result-item';
import { Organization, OrganizationStatusEnum } from '@/types/organizations';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { StatusBadge } from '@kintsugi/ui';

interface OrganizationSearchResultsProps {
  organizations: Organization[];
  isLoading: boolean;
  searchQuery: string;
  onOrgSelect: (org: Organization) => void;
  maxHeight?: string;
}

export const OrganizationSearchResults = ({
  organizations,
  isLoading,
  searchQuery,
  onOrgSelect,
  maxHeight = '300px',
}: OrganizationSearchResultsProps) => {
  if (isLoading) {
    return (
      <Box p={3}>
        <Text fontSize="sm" color="gray.500">
          Searching...
        </Text>
      </Box>
    );
  }

  if (organizations.length > 0) {
    return (
      <VStack gap={0} align="stretch" maxHeight={maxHeight} overflowY="auto">
        {organizations.map(org => (
          <FilterSearchResultItem key={org.id} onSelect={() => onOrgSelect(org)}>
            <VStack gap={1} align="start">
              <HStack>
                <Text fontSize="sm" fontWeight="medium">
                  {org.name}
                </Text>
                {org.is_test && (
                  <StatusBadge size="sm" colorPalette="orange">
                    TEST
                  </StatusBadge>
                )}
                {org.status === OrganizationStatusEnum.ARCHIVED && (
                  <StatusBadge size="sm" colorPalette="red">
                    ARCHIVED
                  </StatusBadge>
                )}
              </HStack>
              <Text fontSize="xs" color="gray.500">
                ID: {org.id}
              </Text>
            </VStack>
          </FilterSearchResultItem>
        ))}
      </VStack>
    );
  }

  if (searchQuery.length > 0) {
    return (
      <Box p={3}>
        <Text fontSize="sm" color="gray.500">
          No organizations found
        </Text>
      </Box>
    );
  }

  return null;
};
